import { PagePath } from '@zep/common/routes';
import { Colors } from '@zep/ui-tokens';
import { getResizedImage } from '@zep/utils';
import { ExportIcon } from '../../../icons';
import { usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
export const SpaceInfoSection = () => {
  const {
    planPaymentInfo
  } = usePlanPaymentInfoContext();
  return <div className="w-full border-b border-[#27262E14] bg-white px-[20px] py-[16px]" data-sentry-component="SpaceInfoSection" data-sentry-source-file="SpaceInfoSection.tsx">
      <div className="flex w-full items-center gap-[14px]">
        <div className="flex h-[72px] min-h-[72px] w-[108px] min-w-[108px] items-center justify-center overflow-hidden rounded-xs border border-[#0000001A] object-cover">
          <img src={getResizedImage(planPaymentInfo?.space.thumbnailUrl, 150)} alt="" />
        </div>
        <div className="flex flex-col justify-center gap-3xs truncate">
          <span className="truncate text-[14px] font-semibold text-[#27262EE5]">
            {planPaymentInfo?.space.name}
          </span>
          <div className="flex cursor-pointer items-center gap-3xs" onClick={() => {
          window.open(PagePath.Root + '/play/' + planPaymentInfo?.space.entryMapHashId, '_blank');
        }}>
            <ExportIcon width={14} height={14} fill={Colors.Gray600} data-sentry-element="ExportIcon" data-sentry-source-file="SpaceInfoSection.tsx" />
            <span className="text-body-2-r font-regular text-gray-600">
              {/*{`${PagePath.Root}/play/${planPaymentInfo?.space.hashId}`}*/}
              {`zep.us/play/${planPaymentInfo?.space.entryMapHashId}`}
            </span>
          </div>
        </div>
      </div>
    </div>;
};